import React from 'react';
import { useTranslation } from "react-i18next";
import { Spinner } from 'react-bootstrap';
function Loader({
  theSize = 'n'
}) {
  const {
    t
  } = useTranslation();
  // Set the dimensions based on theSize
  const dimensions = theSize === 'n' ? '2rem' : '4rem';
  return <Spinner animation="border" role="status" className="spinner-fast" style={{
    width: dimensions,
    height: dimensions
  }}>
      <span className="visually-hidden">{t("ui.components.loader.loading")}</span>
    </Spinner>;
}
export default Loader;
